module.exports = __webpack_public_path__ + "img/janaina.b6a977b2.png";